import * as React from "react";
import PricingField from "./payment/PricingField";
import { BilledInterval } from "./commons/model/pricing/BilledInterval";
import TaxRate from "./commons/model/pricing/TaxRate";

interface SettingsReactivateAccountFormProps {
  validateEndpoint: string;
  priceExcludingTaxInCents: number;
  currency: string;
  billedInterval: BilledInterval;
  trialPeriodDay: number;
  taxRate?: TaxRate;
  onCouponChanged: (couponId?: string) => void;
  onErrorMessageChanged: (errorMsg?: string) => void;
}

export default class SettingsReactivateAccountForm extends React.Component<SettingsReactivateAccountFormProps> {
  render() {
    return (
      <div id="reactivation-form" className="react-form">
        <div>{i18n["Page.Settings.Account.Subscription.Reactivate.Modal.Content"]}</div>
        <PricingField
          {...this.props}
          setErrorMsg={this.props.onErrorMessageChanged}
          onCouponChanged={this.props.onCouponChanged}
        />
      </div>
    );
  }
}
